import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import JobEditDialogHeader from './JobViewDialogHeader';
import api from '@/utils/apiClient';
import { JobViewBasicDetails } from './JobViewBasicDetails';
import LoadingIcon from 'mdi-react/LoadingIcon';

const JobViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: 'View Job',
    hide: onHide,
  });

  const [state, setState] = React.useState({
    loading: false,
    job: {},
    error: '',
  });

  React.useEffect(() => {
    if (id) getJobById(+id);
  }, [id]);

  const getJobById = async (jobId) => {
    try {
      setState({ ...state, loading: true });
      const { data: res, isSuccess } = await api.cadsAIJob.getJobById(jobId);
      if (isSuccess) {
        setState({ ...state, loading: false, job: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting job details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, job: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, job } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <JobEditDialogHeader modal={modal} job={job} />
      {/*Job Modal Body*/}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting job details...' : error}
            </div>
          </>
        ) : (
          <>
            <JobViewBasicDetails job={job} />
          </>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(JobViewDialog);
